import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "../context/ThemeContext";
import { XCircle, Trash2 } from "lucide-react";

const DeleteProductModal = ({ isOpen, onClose, onConfirm, product }) => {
  const { darkMode } = useTheme();

  if (!isOpen || !product) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-opacity-80 ${
        darkMode ? "bg-black" : "bg-gray-500"
      }`}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className={`p-8 rounded-3xl shadow-xl w-[600px] relative ${
          darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          className={`text-3xl font-semibold text-center ${
            darkMode ? "text-red-400" : "text-red-600"
          }`}
        >
          Sigur doriți să ștergeți acest produs?
        </h3>
        <p className="text-center mt-4 text-xl">
          <strong>{product.name}</strong> va fi șters definitiv.
        </p>

        {/* ✅ Gombok */}
        <div className="flex justify-between mt-8 gap-6">
          <button
            onClick={onClose}
            className={`w-full px-6 py-5 rounded-3xl transition flex items-center justify-center gap-3 text-xl font-semibold ${
              darkMode
                ? "bg-gray-600 text-white hover:bg-gray-500"
                : "bg-gray-500 text-white hover:bg-gray-400"
            }`}
          >
            <XCircle size={24} /> Anulare
          </button>

          <button
            onClick={() => onConfirm(product.id)}
            className={`w-full px-5 py-4 rounded-3xl transition flex items-center justify-center gap-2 text-lg font-semibold ${
              darkMode
                ? "bg-red-700 text-white hover:bg-red-600"
                : "bg-red-600 text-white hover:bg-red-500"
            }`}
          >
            <Trash2 size={24} /> Șterge
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default DeleteProductModal;
